import {
  IAdvIndustryRes,
  IAdvIndustryResItem,
  IAdvIndustry,
  IAdvIndustryKey,
  Level1IndustryOtherId,
  IndustryOtherIdSet
} from "~/types/form";
/**
 * @param  {IAdvIndustryRes[]} data
 * 转换 industry 接口返回的数据
 */
export function generateAdvIndustry(data: IAdvIndustryRes[] = []) {
  return data.map(v => ({
    id: v.industry_type,
    label: v.industry_type,
    children: formatAdvIndustryChildren(v.industry_list)
  }));
}

/**
 * @param  {IAdvIndustryResItem[]} children
 * 转换 industry children
 */
function formatAdvIndustryChildren(
  children: IAdvIndustryResItem[] = []
): IAdvIndustry[] {
  return children.map(child => {
    let item: IAdvIndustry = {
      id: "",
      label: ""
    };
    if (child.children) {
      item = {
        id: child.id,
        label: child.name,
        children: formatAdvIndustryChildren(child.children)
      };
    } else {
      item = {
        id: child.id,
        label: child.name
      };
    }
    if (!child.id) {
      item.key = child.key;
      delete item.id;
    }
    // 简化行业后，有二级行业的一级行业没有id
    return item;
  });
}

/**
 * @param  {IAdvIndustry[]} list
 * 获取禁投行业 id 列表
 */
export function getForbiddenIds(list: IAdvIndustry[] = []): IAdvIndustryKey[] {
  return list.reduce(
    (total: IAdvIndustryKey[], item) => [
      ...total,
      ...(item.children ? getForbiddenIds(item.children) : [item.id])
    ],
    []
  );
}

// 自助行业排序，other放在最后
export const sortIndustryList = (advIndustryList: IAdvIndustry[]) => {
  if (!advIndustryList.length) return [];
  let tempList: IAdvIndustry[] = JSON.parse(JSON.stringify(advIndustryList));
  const level1IndustryOtherItem = tempList.splice(
    tempList.findIndex(item => item.key === Level1IndustryOtherId),
    1
  );
  const forbiddenItem = tempList.splice(
    tempList.findIndex(item => item.id === "forbidden"),
    1
  );
  tempList.sort((a, b) => a?.label.localeCompare(b?.label));
  tempList = [...tempList, ...forbiddenItem, ...level1IndustryOtherItem];
  tempList.forEach(item =>
    item.children?.sort((a, b) => {
      // 二级行业的 Other 类型都放在最后
      if (IndustryOtherIdSet.includes(a?.id)) {
        return 1;
      }
      if (IndustryOtherIdSet.includes(b?.id)) {
        return -1;
      }
      return a?.label.localeCompare(b?.label);
    })
  );
  return tempList;
};
